import { Button, PulseLoader } from '@sparemin/blockhead';
import { useCampaignCreation } from 'pages/AdCampaignPage/CampaignCreationContext';
import PageHeading from 'pages/AdCampaignPage/PageHeading';
import { useCallback } from 'react';
import { useEventTracking } from 'state/eventTracking';
import { useCreditsBalance, useIsProGrow } from 'state/pricing';
import { STEP_TITLES } from '../constants';
import CampaignCredits from './CampaignCredits';
import CampaignDuration from './CampaignDuration';
import { METRIC_BY_CONTENT_TYPE } from './constants';
import CustomBudget from './CustomBudget';
import PricingOptions from './PricingOptions';
import * as S from './styles';

export interface ObjectiveStepProps {
  onContinue: () => void;
}

const ObjectiveStep: React.FC<ObjectiveStepProps> = ({ onContinue }) => {
  const {
    state: {
      isCustomBudget,
      isValidCustomBudget,
      values: { campaignBudgetMilliCent, episode },
    },
  } = useCampaignCreation();
  const { trackPodcastPromoPurchaseNext } = useEventTracking();

  const { data: isProGrow, isLoading: isProGrowLoading } = useIsProGrow();
  const { data: creditsBalance, isLoading: isCreditsBalanceLoading } =
    useCreditsBalance();

  const handleContinue = useCallback((): void => {
    trackPodcastPromoPurchaseNext({
      step: 'Objective',
      budget: campaignBudgetMilliCent,
    });
    onContinue();
  }, [campaignBudgetMilliCent, onContinue, trackPodcastPromoPurchaseNext]);

  const metric = episode && METRIC_BY_CONTENT_TYPE[episode.type];

  if (isProGrowLoading || isCreditsBalanceLoading) {
    return <PulseLoader />;
  }

  return (
    <>
      <PageHeading
        title={STEP_TITLES.objective}
        titleId="title"
        description={
          metric &&
          `You only pay for the ${metric} you get, so no dollar is wasted.`
        }
      />

      <PricingOptions />

      {isCustomBudget && <CustomBudget />}

      <S.CampaignCardsContainer orientation="vertical" space="12px">
        <CampaignDuration />

        {isProGrow && <CampaignCredits remaining={creditsBalance?.remaining} />}
      </S.CampaignCardsContainer>

      <Button
        fluid
        isDisabled={
          isCustomBudget && (!campaignBudgetMilliCent || !isValidCustomBudget)
        }
        onPress={handleContinue}
      >
        review your order
      </Button>
    </>
  );
};

export default ObjectiveStep;
